import copyToClipboard from "./copyToClipboard";

export const isShareSupported = (data: ShareData) => {
  return !!navigator.canShare && navigator.canShare(data);
};

/**
 * 인자로 받은 data를 OS 기본옵션으로 공유합니다.
 * 기본 공유옵션이 지원되지 않을 경우, url만을 클립보드에 링크를 복사하는 기능으로 대체됩니다.
 *
 * @example
 * ```ts
 * const result = await shareHandler("data");
 * if (result === "share") {
 *   console.log("공유 성공");
 * } else if (result === "copiedToClipboard") {
 *   console.log("클립보드 복사 성공");
 * } else {
 *   console.log("공유 실패");
 * }
 * ```
 */

export const shareHandler = (data: ShareData) => {
  return new Promise<"shared" | "copiedToClipboard" | "failed">(
    async (resolve) => {
      if (isShareSupported(data)) {
        await navigator.share(data);
        resolve("shared");
        return "shared";
      }

      if (data.url) {
        const result = await copyToClipboard(data.url);

        if (result) {
          resolve("copiedToClipboard");
          return "copiedToClipboard";
        }
      }

      resolve("failed");
      return "failed";
    },
  );
};

export default shareHandler;
